import React, { Component } from "react";
import { connect } from "react-redux";
import { bool, func } from "prop-types";
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import { Row, Col, Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { getMessage } from "CONFIG/i18n";
import * as log from "loglevel";
import { sessionActions as actionFactory } from "CONFIG/ActionFactory";
import { inviteeAction as actionfactory } from "CONFIG/ActionFactory";
import { audioVideoAction } from "CONFIG/ActionFactory";

import "../AddInvitee/AddInvitee.less";
import "./WaitingArea.less";
import AddInvitee from "../AddInvitee/AddInvitee";
import InviteHistory from "../AddInvitee/InviteHistory";
import AllowEditSwitch from "COMPONENTS/CommonComponents/Switch/AllowEditSwitch";
import EvictParticipantConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";

import ic_attendee_audio_on_disabled from "ASSETS/Images/waiting_area/ic_audio_on_disable.svg";
import ic_attendee_audio_off_disabled from "ASSETS/Images/waiting_area/ic_audio_off_disable.svg";
import ic_attendee_audio_on from "ASSETS/Images/waiting_area/ic_audio_on.svg";
import ic_attendee_audio_off from "ASSETS/Images/waiting_area/ic_audio_off.svg";
import ic_attendee_video_on from "ASSETS/Images/waiting_area/ic_video_on.svg";
import ic_attendee_video_off from "ASSETS/Images/waiting_area/ic_video_off.svg";
import ic_attendees from "ASSETS/Images/ic_attendees.svg";
import ic_attendee_video_on_disabled from "ASSETS/Images/waiting_area/ic_video_on_disable.svg";
import ic_attendee_video_off_disabled from "ASSETS/Images/waiting_area/ic_video_off_disable.svg";
import waitingRoom from "ASSETS/Images/Waiting_Room.svg";
import ic_host from "ASSETS/Images/ic_host.svg";
import ic_close_waiting_room from "ASSETS/Images/ic_close_waiting_room.svg";
import ic_presenter from "ASSETS/Images/ic_presenter.svg";
import ic_co_browse from "ASSETS/Images/waiting_area/ic_co_browse_waiting_room.svg";

// CONSTANTS
import { USER_ADMISSION_STATUS, USER_ROLES, PARTICIPANT_STATUS } from "UTILS/Constants";
import { mediaType } from "WEBSOCKET/constants";
import { isIE, isMobile } from "react-device-detect";
import { mediaStatus } from "WEBSOCKET/constants";

import { getUserNameForSelectedLanguage, setSMSMessage } from "UTILS/Utility";
import modalScrollBar from "../ModalScrollBar/ModalScrollBar";

import Participants from "../CommonComponents/Header/Participants/Participants";

// Selector
import { selectIsSMSEnabled } from "REDUX/Selector/OrganisationSelector";

class WaitingArea extends Component {
    static propTypes = {
      show: bool,
      addInviteeHandle: func,
    };
    constructor(props) {
      super(props);
      this.state = {
        addInviteeManual: false,
        addInviteeHistory: false,
        currentSessionInvitees: [],
        buttonIndex: null,
        participantButtonIndex: null,
        showEvictParticipantConfirmationModal: false,
        evictParticipantId: null,
        isReductionLogs: this.props.isReductionLogs ? (this.props.isReductionLogs.isEnable ? true : false) : false,
      };
    }

    toggle = () => {
      this.props.showWaitingArea();
    };

    makePresenter = (participant) => {
      this.props.makePresenter(participant);
    };

    componentDidMount() {
      setSMSMessage(this, ["MANUAL_ENTRY_NON_SMS"]);
    }

    addInviteeManualHandle = () => {
      this.toggle();
      this.setState({ addInviteeManual: !this.state.addInviteeManual });
    };

    addInviteeHistoryHandle = () => {
      this.toggle();
      this.setState({ addInviteeHistory: !this.state.addInviteeHistory });
    };
    handleSendClick = (invitees, value) => {
      if (value) {
        this.setState({ addInviteeManual: !this.state.addInviteeManual });
      } else {
        this.setState({ addInviteeHistory: !this.state.addInviteeHistory });
      }
      actionFactory
      .inviteUser(this.props.sessionKey, invitees, this.props.language)
      .then(
        (data) => {
          toastr.info(getMessage("INVITATION_SENT"));
          log.info("Data:", data);
        },
        (error) => {
          toastr.info(getMessage("INVITATION_NOT_SENT"));
          log.error("ERROR: ", error);
        }
      );
    };

    handleAllowEdit = (allowEditAccess,participantId) => {
      // Only agent can change edit permission
      if(this.props.uniqueId === this.props.organiser){
        this.props.handleAllowEdit(allowEditAccess, participantId)
      }
    }

    handleaddInviteHistory = () => {
      actionfactory.addInviteeAction(this.props.sessionKey).then(
        (data) => {
          if (
            data.data.invitees === undefined ||
                    data.data.invitees.length === 0
          ) {
            toastr.info(getMessage("NO_INVITEES"));
          } else {
            this.addInviteeHistoryHandle();
            this.setState({
              currentSessionInvitees: data.data.invitees,
            });
          }
        },
        (error) => {
          log.error("ERROR: ", error);
        }
      );
    };

    handleManualEntry = () => {
      return (
        <AddInvitee
          show={this.state.addInviteeManual}
          addInviteeManualHandle={this.addInviteeManualHandle}
          handleSendClick={this.handleSendClick}
          isSMSEnabled={this.props.isSMSEnabled}
        />
      );
    };
    handleInviteHistory = () => {
      return (
        <InviteHistory
          show={this.state.addInviteeHistory}
          addInviteeHistoryHandle={this.addInviteeHistoryHandle}
          currentSessionInvitees={this.state.currentSessionInvitees}
          handleSendClick={this.handleSendClick}
        />
      );
    };

    viewParticipantsButtons = (index) => {
      this.setState({ participantButtonIndex: index });
    };

    componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClickEvictParticipantModal);
    }

    handleOutsideClickEvictParticipantModal = (event) => {
      if (event.target.className == 'modal fade show') {
        this.setState({
          showEvictParticipantConfirmationModal: false,
          evictParticipantId: null,
          evictParticipantName: null
        });
        document.removeEventListener('click', this.handleOutsideClickEvictParticipantModal);
      }
    }

    onOpenEvictParticipantConfirmationModal = (showConfirmationModal, participantId, participantName) => {
      this.setState({
        showEvictParticipantConfirmationModal: showConfirmationModal,
        evictParticipantId: participantId,
        evictParticipantName: participantName
      });
      this.closeModal = this.handleOutsideClickEvictParticipantModal.bind(this);
      document.addEventListener('click', this.handleOutsideClickEvictParticipantModal);
    }

    getAdmittedParticipantRow = (participant, index) => {
      if(participant) {
        try {
          let participantName = participant.role === USER_ROLES.AGENT
            ? getUserNameForSelectedLanguage(this.props.language, participant.userName)
            : participant.userName;
          return (
            <Row
              className="alignParticipants mx-0"
              key={index + "12"}
              onMouseOverCapture = {() =>
                this.viewParticipantsButtons(
                  index
                )
              }
              onMouseLeave = { () =>
                this.viewParticipantsButtons(
                  null
                )
              }
            >
              <Col className={ "d-flex flex-row px-0 col-xs-12 "+ (
                this.props.isOrganiser
                  ? "col-12 col-sm-6"
                  : "col-10 col-sm-9")
              }>
                {/* agent or user icon */}
                <img
                  src={
                    this.props.presenter === participant.uniqueId
                      ? ic_presenter
                      : participant.role === USER_ROLES.AGENT
                        ? ic_host
                        : ic_attendees
                  }
                  alt = ""
                />
                {/* user name */}
                <Col 
                  className={participant.role === USER_ROLES.AGENT
                    ? "ellipsedText agentText userNameText"
                    : "ellipsedText userNameText"}
                  title={participantName}
                >
                  {participantName}
                </Col>
                {/* mute / unmute  audio / video icons if audio / video call is going on */}
                {
                  (participant.mediaType === mediaType.AUDIO 
                    || participant.mediaType === mediaType.AUDIO_VIDEO) && (
                    <div
                      className="pr-1 pl-1 d-flex justify-content-center"
                    >
                      <img
                        src={participant.audioStatus === mediaStatus.UNMUTED
                          ? this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId 
                            ? ic_attendee_audio_on 
                            : ic_attendee_audio_on_disabled
                          : this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId 
                            ? ic_attendee_audio_off 
                            : ic_attendee_audio_off_disabled
                        }
                        className={ this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId 
                          ? "cursorPointer waitingAreaIcons"
                          : "waitingAreaIcons" }
                        onClick={(e) => {
                          // restrict click of audio/video box
                          if(this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId) {
                            e.stopPropagation()
                            audioVideoAction.toggleMedia(
                              this.props.sessionKey,
                              mediaType.AUDIO,
                              participant.audioStatus === mediaStatus.UNMUTED
                                ? mediaStatus.MUTED_BY_AGENT 
                                : mediaStatus.UNMUTED,
                              // participant.audioStatus,
                              participant.uniqueId
                            )
                          }
                        }
                        }
                        title={participant.audioStatus === mediaStatus.UNMUTED
                          ? this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId 
                            ? getMessage("MUTE_AUDIO")
                            : null
                          : this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId 
                            ? getMessage("UNMUTE_AUDIO")
                            : null
                        }
                      />
                    </div>
                  )
                }
                {
                  this.isVideoBlockShow() && 
                    <div className="pr-1 pl-1 d-flex justify-content-center">
                      {
                        participant.mediaType === mediaType.AUDIO_VIDEO && 
                          <img
                            src={participant.videoStatus === mediaStatus.UNMUTED
                              ? this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId 
                                ? ic_attendee_video_on 
                                : ic_attendee_video_on_disabled
                              : this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId 
                                ? ic_attendee_video_off 
                                : ic_attendee_video_off_disabled
                            }
                            alt=""
                            className={ this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId 
                              ? "cursorPointer waitingAreaIcons"
                              : "waitingAreaIcons" }
                            onClick={(e) => {
                              // restrict click of audio/video box
                              if(this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId) {
                                e.stopPropagation()
                                audioVideoAction.toggleMedia(
                                  this.props.sessionKey,
                                  mediaType.AUDIO_VIDEO,
                                  participant.videoStatus === mediaStatus.UNMUTED
                                    ? mediaStatus.MUTED_BY_AGENT 
                                    : mediaStatus.UNMUTED,
                                  // participant.videoStatus,
                                  participant.uniqueId
                                )
                              }
                            }}
                            title={participant.videoStatus === mediaStatus.UNMUTED
                              ? this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId 
                                ? getMessage("MUTE_VIDEO")
                                : null
                              : this.props.isOrganiser && participant.uniqueId !== this.props.uniqueId 
                                ? getMessage("UNMUTE_VIDEO")
                                : null
                            }
                          />
                      }
                    </div>
                }
                { this.isCobrowseBlockShow() &&
                  <div className="pr-1 pl-1 d-flex align-items-center justify-content-center">
                    {
                      (participant.cobrowseStatus || participant.customerCoBrowseStatus) && 
                        <img
                          src={ic_co_browse}
                          alt=""
                          className=""
                        />
                    }
                  </div>
                }
              </Col>

              <Col className={ "col-xs-12 participantsOptions "+ (
                this.props.isOrganiser
                  ? "col-sm-6 col-12 px-0"
                  : isIE ? "col-sm-3 col-2 pl-0" :"col-sm-3 col-2 px-0")
              }>
                <Row className="w-100 mx-0 participantsOptions">
                  {((participant.uniqueId !== this.props.organiser 
                      && this.props.isOrganiser
                      && participant.allowEditAccess !== undefined) 
                   || (this.props.uniqueId === participant.uniqueId 
                       && participant.uniqueId !== this.props.organiser 
                      && participant.allowEditAccess)) &&
                <Col className="col-2 d-flex justify-content-center">
                  <AllowEditSwitch
                    switchOn={participant.allowEditAccess}
                    disabled={!this.props.isOrganiser}
                    toggleSwitch={(allowEdit) => this.handleAllowEdit(allowEdit, participant.uniqueId)}
                  />
                </Col>
                  }
                  <Col className="col-10 d-flex flex-row-reverse">
                    {(index === this.state.participantButtonIndex || isMobile) && (
                      <div
                        className={(this.props.isOrganiser && this.props.uniqueId === participant.uniqueId ? "makePresenterButtonForAgent" : "mr-2") + " pl-1"}
                      >
                        {this.props.presenter !== participant.uniqueId &&
                          participant.token &&      // Token check added to avoid make user presenter before user arrived
                          this.props.isOrganiser && (
                          <Button
                            onClick={() => {
                              this.makePresenter(
                                participant
                              );
                            }}
                            className="admitButton whiteOnClick"
                          >
                            {getMessage(
                              "MAKE_PRESENTER"
                            )}
                          </Button>
                        )}
                      </div>
                    )}
                    {(participant.uniqueId !== this.props.organiser && 
                      participant.token &&      // Token check added to avoid evict user before user arrived 
                      this.props.isOrganiser 
                      && (index === this.state.participantButtonIndex || isMobile)) &&
                      <Button 
                        onClick={() => {
                          this.onOpenEvictParticipantConfirmationModal(true, participant.participantId, participant.userName);
                        }}
                        className="mr-3 kickButton whiteOnClick"
                      >{getMessage("KICK_PARTICIPANT")}
                      </Button>
                    }
                  </Col>
                  {/* {index === this.state .participantButtonIndex && (
                  <div
                    className="pr-1"
                  >
                    <Button className="connectButton whiteOnClick">
                      {
                        "Connect via phone"
                      }
                    </Button>
                  </div>
                )} */}
                </Row>
              </Col>
            </Row>
          );
        } catch(error) {
        // supressing the error since participants list gets empty abruptly when agent refreshes the page
          console.log("Error while rendering admitted participants..supressing");
          return "";
        }
      }
    }

    //reserv the cobrowse space for all participant when one of the participant shown cobrowse icon
    isCobrowseBlockShow = () => {
      let showCobrowseBlock = false
      this.props.admittedParticipants.forEach(participant => {
        if(participant.cobrowseStatus || participant.customerCoBrowseStatus){
          showCobrowseBlock = true;
          return;
        }
      });
      return showCobrowseBlock;
    }

    //reserv the video icon space for all participant when one of the participant shows video icon
    isVideoBlockShow = () =>{
      let showVideoBlock = false;
      this.props.admittedParticipants.forEach(participant => {
        if(participant.mediaType === mediaType.AUDIO_VIDEO){
          showVideoBlock = true;
        }
      });
      return showVideoBlock;
    }

    getWaitingParticipantRow = (user, index) => {
      try {
        if(!this.state.isReductionLogs){
          return (
            <Row
              className="alignWaitingUser mx-0"
              key={index}
            >
              <Col md={1} lg={1} sm={1} xs={1}
                className="justify-content-left justify-content-md-center px-0 waitingIcon"
              >
                <img
                  src={waitingRoom}
                  alt=""
                  // className="pl-2 pr-2"
                />
              </Col>
              <Col md={7} lg={7} sm={7} xs={11}
                className="ellipsedText userNameText pl-0"
                title={user.userName}
              >
                {user.userName}
              </Col>
              <Col
                className="pull-right pr-0 pl-0"
              >
                <div className="pull-right">
                  {
                    <Button
                      className="ml-3 mr-2 admitButton whiteOnClick"
                      onClick={() =>
                        this.props.admitOrRejectUserInSession(
                          true,
                          user.uniqueId,
                          true
                        )
                      }
                    >
                      {getMessage("ADMIT")}
                    </Button>
                  }
                  {
                    <Button
                      className="ml-2 dismissButton whiteOnClick"
                      onClick={() =>
                        this.props.admitOrRejectUserInSession(
                          false,
                          user.uniqueId,
                          true
                        )
                      }
                    >
                      {getMessage("DISMISS")}
                    </Button>
                  }
                </div>
              </Col>
            </Row>
          );
        }
      } catch(error) {
        // supressing the error since participants list gets empty abruptly when agent refreshes the page
        console.log("Error while rendering waiting participants..supressing");
        return "";
      }
    }

    render() {
      let participant = null;
      let waitingParticipants = this.props.allParticipants.filter(
        (participant) =>
          participant.admissionStatus == USER_ADMISSION_STATUS.PENDING &&
                (participant.status === PARTICIPANT_STATUS.ACTIVE ||
                    participant.status === PARTICIPANT_STATUS.WAITING)
      );
      let admittedParticipants = this.props.allParticipants.filter(
        (participant) =>
          participant.admissionStatus == USER_ADMISSION_STATUS.ADMITTED &&
                participant.status === PARTICIPANT_STATUS.ACTIVE
      );
      // console.log("admittedParticipants before:", admittedParticipants);
      if(admittedParticipants.length > 1) {
        let agentIndex = _.findIndex(admittedParticipants, 
          participant => participant && participant.role === USER_ROLES.AGENT);
        let agentParticipant = admittedParticipants[agentIndex];
        admittedParticipants.splice(agentIndex, 1);
        admittedParticipants.push(agentParticipant);

        // Get participant i.e. user to display 'Allow Edit' title if allowEditAccess = true
        let participantIndex = _.findIndex(admittedParticipants, 
          participant => participant && participant.uniqueId === this.props.uniqueId);
        participant = admittedParticipants[participantIndex];
      }
      // console.log("admittedParticipants after:", admittedParticipants);
      return (
        <div className="popUp waitingArea">
          {this.handleManualEntry()}
          {this.handleInviteHistory()}
          <Modal
            isOpen={this.props.show}
            className="modal-wrapper modal-md modalContainer waitingArea"
            xs="8"
          >
            <ModalHeader toggle={this.toggle} className="d-none" />
            <ModalBody className="popupBody modalBody pt-0">
              <div>
                {
                  <div className="pt-1">
                    <span className="userNameText">
                      {this.props.isOrganiser &&
                        waitingParticipants &&
                        waitingParticipants.length > 0 &&
                        getMessage("WAITING_AREA") + ":"}
                    </span>
                    <span className="subText">
                      {this.props.isOrganiser &&
                        waitingParticipants &&
                        waitingParticipants.length > 0 &&
                        ` ${getMessage("USERS_WAITING", {
                          count:
                                waitingParticipants.length,
                        })}`}
                    </span>
                    {waitingParticipants.length > 0 && (
                      <img
                        src={ic_close_waiting_room}
                        alt={""}
                        className="pull-right cursorPointer pt-1"
                        onClick={this.toggle}
                      />
                    )}
                  </div>
                }
                {this.props.isOrganiser &&
                waitingParticipants &&
                waitingParticipants.length > 0 &&
                waitingParticipants.map((user, index) => {
                  return user.uniqueId ? this.getWaitingParticipantRow(user, index): ""
                })}
              </div>
              <div>
                <div>
                  {waitingParticipants.length === 0 && (
                    <img
                      src={ic_close_waiting_room}
                      alt={""}
                      className="pull-right cursorPointer pt-1"
                      onClick={this.toggle}
                    />
                  )}
                </div>
                <div className="pt-4">
                  <span className="userNameText">
                    {getMessage("ATTENDEES")}
                  </span>
                                :
                  <span className="subText">
                    {/* {this.props.isOrganiser &&
                      admittedParticipants.length > 0 &&
                      ` ${getMessage("PARTICIPANT_COUNT", {
                        count: admittedParticipants.length,
                        totalCount:
                              admittedParticipants.length +
                              waitingParticipants.length,
                      })}`} */}
                  </span>
                  {/*
                    Display Allow Edit title to agent and if admitted participants are there
                    OR 
                    display title to user because it shows switch in disabled state when allowEditAccess=true. 
                  */}
                  {((this.props.isOrganiser &&
                      admittedParticipants.length > 1) || (participant && this.props.uniqueId === participant.uniqueId && participant.uniqueId !== this.props.organiser && participant.allowEditAccess)) &&<span className="userNameText pull-right">
                  </span>}
                </div>
                <div>
                  {admittedParticipants &&
                  admittedParticipants.length > 0 &&
                  admittedParticipants.map(
                    (participant, index) => {
                      return this.getAdmittedParticipantRow(participant, index);
                    }
                  )}
                </div>
              </div>
              {this.props.isOrganiser && (
                <Row className="">
                  {/* {this.props.addInvitee(true)} */}
                  <div className="col-12  col-sm-4 col-md-4 col-lg-4 pb-1 pt-1">
                    <Button
                      className="buttonTextFont admitButton whiteOnClick ripple w-100"
                      onClick={this.addInviteeManualHandle}
                    >
                      {getMessage(this.state.manualEntryMsg)}
                    </Button>
                  </div>

                  {/* <br /> */}
                  <div className="col-12  col-sm-4 col-md-4 col-lg-4 pb-1 pt-1">
                    <Button
                      className="buttonTextFont admitButton whiteOnClick w-100"
                      onClick={this.handleaddInviteHistory}
                    >
                      {getMessage("INVITE_HISTORY")}
                    </Button>
                  </div>
                  {/* <br /> */}
                  <div className="col-12  col-sm-4 col-md-4 col-lg-4 pb-1 pt-1">
                    {isIE ? (
                      <Button
                        disabled={
                          this.props.sessionLink
                            ? false
                            : true
                        }
                        className="buttonTextFont admitButton whiteOnClick w-100"
                        onClick={() => {
                          window.clipboardData && 
                            window.clipboardData.setData("Text",this.props.sessionLink);
                          if (window.clipboardData &&
                            window.clipboardData.getData("Text")
                          )
                            toastr.info(getMessage("SESSION_LINK_COPIED"));
                          else
                            toastr.info(getMessage("SESSION_LINK_NOT_COPIED"));
                        }}
                      >
                        {getMessage("COPY_SESSION_LINK")}
                      </Button>
                    ) : (
                      <CopyToClipboard
                        text={this.props.sessionLink}
                        onCopy={(text, result) => {
                          if (result)
                            toastr.info(getMessage("SESSION_LINK_COPIED"));
                          else
                            toastr.info(getMessage("SESSION_LINK_NOT_COPIED"));
                        }}
                      >
                        <Button
                          disabled={
                            this.props.sessionLink
                              ? false
                              : true
                          }
                          className="buttonTextFont admitButton whiteOnClick w-100"
                        >
                          {getMessage(
                            "COPY_SESSION_LINK"
                          )}
                        </Button>
                      </CopyToClipboard>
                    )}
                  </div>
                </Row>
              )}
            </ModalBody>
          </Modal>
          {this.state.showEvictParticipantConfirmationModal &&
            <EvictParticipantConfirmationModal
              show={true}
              isDoubleButton={true}
              handleNoClick={() => { this.onOpenEvictParticipantConfirmationModal(false, null, null) }}
              handleYesClick={() => {
                this.props.evictAction(this.state.evictParticipantId);
                this.onOpenEvictParticipantConfirmationModal(false, null, null);
              }}
              message={getMessage("EVICT_PARTICIPANT_CONFIRMATION_TEXT",
                {participantName: (this.state.evictParticipantName) })}
            />
          }
        </div>
      );
    }
}
const mapStateToProps = (state) => {
  return {
    // sessionKey: selectSessionKey(state)
    isSMSEnabled: selectIsSMSEnabled(state),
  };
};
export default modalScrollBar(connect(mapStateToProps)(WaitingArea));
